import React, { useEffect, useRef, useState } from "react";
import { SEARCH_TEXT_SEPARATOR, TBL_DATA_SEPARATOR } from "../constants/commonConstants";

const SearchColumnSelect = ({ data, setData, columns = [], isNoColumn = false, storeSessionKey, sessionData, targetAccessor = "showData" }) => {

    const defaultSearchColumnValue = "--all--"

    const initialSearchDataObj = sessionStorage.getItem(storeSessionKey);
    const initialSearchData = storeSessionKey && initialSearchDataObj ? JSON.parse(initialSearchDataObj) : null;

    const [searchText, setSearchText] = useState(initialSearchData?.searchText || "");
    const [searchColumn, setSearchColumn] = useState(initialSearchData?.searchColumn || defaultSearchColumnValue);

    const searchInputRef = useRef(null);

    useEffect(() => {
        let filteredList = data || [];

        if (filteredList.length <= 0 || !searchText) {
            setData(filteredList);
        } else if (isNoColumn) {
            const searchWords = searchText.trim().toLowerCase().split(SEARCH_TEXT_SEPARATOR);
            filteredList = filteredList.filter(item => {
                const targetTextArr = (item[targetAccessor].text.toLowerCase() || '').split(TBL_DATA_SEPARATOR);
                return searchWords.every(word => targetTextArr.some(str=> str?.trim().includes(word?.trim())));
            });
            setData(filteredList);
        } else {
            if (searchColumn === defaultSearchColumnValue) {
                filteredList = filteredList?.filter(data =>
                    Object.entries(data).filter(([key]) =>
                        columns.filter(column => column.unSearchable !== true)?.map(a => a.accessor)?.includes(key))
                        ?.some(([_, value]) => value?.toString()?.toLowerCase()?.includes(searchText?.trim()?.toLowerCase()))
                );
            } else {
                filteredList = filteredList?.filter(data =>
                    data[searchColumn]?.toString()?.toLowerCase()?.includes(searchText?.trim()?.toLowerCase())
                );
            }
            setData(filteredList);
        }

        if (storeSessionKey && sessionData) {
            const searchData = {
                ...sessionData,
                searchText,
                searchColumn
            }
            sessionStorage.setItem(storeSessionKey, JSON.stringify(searchData));
        }

    }, [searchColumn, searchText, data]);

    return (
        <>
            {!isNoColumn && <select className='customInputControl me-2' value={searchColumn} onChange={(e) => setSearchColumn(e.target.value)}>
                <option value={defaultSearchColumnValue}>--All Column--</option>
                {
                    columns.filter(column => column.unSearchable !== true).map(column => (
                        <option key={column.accessor} value={column.accessor}>{column.Header}</option>
                    ))
                }
            </select>}
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <input ref={searchInputRef} className='customInputControl txt-search' type='text' placeholder='Search Text' value={searchText} autoComplete="off"
                    onChange={(e) => setSearchText(e.target.value)} style={{ paddingRight: '30px' }} />
                <button type="button" className='icon-btn input-icon'
                    style={{
                        pointerEvents: `${!searchText ? 'none' : 'auto'}`,
                        color: `${!searchText ? '' : 'red'}`
                    }}
                    onClick={() => {
                        if (searchText) {
                            setSearchText("");
                            setTimeout(() => {
                                searchInputRef.current?.focus();
                            }, 0);
                        }
                    }}
                >
                    <i className={`bi ${!searchText ? 'bi-search' : 'bi-x-circle'}`}></i>
                </button>
            </div>
        </>
    )
}

export default SearchColumnSelect;